import store from '@state/store';

// const defaultNumber = store.getters['auth/user'].number;
const defaultCity = store.getters['app/cityId'];

// export default function isBDPhoneNumber(phoneNumber = defaultNumber) {
//   const pattern = /^(?:(?:\+|00)88|01)?\d{11}$/;
//   return pattern.test(phoneNumber);
// }

// If city code other than 4 , return true
export default function isBDPhoneNumber(cityCode = defaultCity) {
  return cityCode !== 4;
}
